<!-- Overrides @basecom-gmbh/pond/pages/checkout/cart.vue -->
<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
const { isEmpty } = useCart();
const { checkoutBreadcrumbs } = useStaticBreadcrumbs();
const cartItemsStore = useCartItemsStore();

useAnalytics({ trackPageView: true, pageType: 'cart' });
useBreadcrumbs(checkoutBreadcrumbs({ index: 0 }));

const { cartItemsCount } = storeToRefs(cartItemsStore);
</script>

<template>
    <div class="container pt-2">
        <!--        CUSTOM IDS-154: Changed styling-->
        
<FormKitLazyProvider config-file="true">
<div class="flex w-full items-end justify-between sm:justify-start">
            <h1 class="whitespace-nowrap font-extrabold leading-8">
                {{ $t('checkout.cart.heading') }}
            </h1>
            <span
                v-if="cartItemsCount === 0 || cartItemsCount > 1"
                class="text-sm sm:ml-4"
            >
                {{ $t('checkout.cart.headingProductCount', { count: cartItemsCount }) }}
            </span>
            <span
                v-if="cartItemsCount === 1"
                class="text-sm sm:ml-4"
            >
                {{ $t('checkout.cart.headingProductCountOne') }}
            </span>
        </div>

        <div
            v-if="!isEmpty"
            class="my-4 flex w-full flex-wrap gap-8 lg:flex-nowrap"
        >
            <div class="w-full lg:w-2/3">
                <CheckoutCart />
            </div>
            <div class="flex w-full flex-col gap-4 lg:w-1/3">
                <CheckoutSummary />

                <LocaleLink :to="'/checkout/confirm'">
                    <FormKit
                        type="submit"
                        :classes="{
                            outer: 'w-full',
                            input: '!w-full',
                            wrapper: 'w-full',
                        }"
                    >
                        {{ $t('checkout.cart.checkoutButtonLabel') }}
                    </FormKit>
                </LocaleLink>

                <CheckoutPromotion />
            </div>
        </div>

        <template v-if="isEmpty">
            <div class="my-32 flex h-full flex-col flex-wrap items-center justify-center sm:my-16">
                <img
                    src="/assets/icons/ids_empty_cart.svg"
                    :alt="$t('checkout.cart.altEmptyCart')"
                />
                <span class="non-italic text-lg font-extrabold leading-6">{{
                    $t('checkout.cart.emptyCartMessage')
                }}</span>
            </div>
        </template>
</FormKitLazyProvider>

    </div>
</template>
